import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerChangeClientListenersForSwap } from '@/store/swap/listeners/change-client-listener.ts';
import { registerDuplicateSwapTradeCaptureListenersForCash } from '@/store/swap/listeners/duplicate-swap-trade-capture-listeners.ts';
import { registerRfsListenersForSwap } from '@/store/swap/listeners/rfs-listener.ts';
import { registerSwapTradeCaptureQueueCleanupListener } from '@/store/swap/listeners/swap-queue-cleanup-listener.ts';

export function registerSwapListeners(startAppListening: StartAppListening): void {
  registerChangeClientListenersForSwap(startAppListening);
  registerRfsListenersForSwap(startAppListening);
  registerDuplicateSwapTradeCaptureListenersForCash(startAppListening);
  registerSwapTradeCaptureQueueCleanupListener(startAppListening);
}
